import React from 'react';
import { call } from 'redux-saga/effects';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { DatasourceCard } from '~src/datasource/components/cards/DatasourceCard';
import { ConnectedDatasourceDetailsDialogBody } from '~src/datasource/components/DatasourceDetailsDialog';
import { IDataSourceDetailInfoWithUsage, IDataSourceInfo } from '~src/datasource/models/IDataSourceInfo';
import { DataSources } from '~src/datasource/resources/Datasources';
import { IDatasourceActions } from '~src/datasource/ServerApi/types/IDatasourceActions';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import {
  ContentTypeFilterClause,
  MixedContentItemDefinition,
  SpaceDefinition
} from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { DatasourceContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getDatasourceInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { getDataSourceDefaultFilters } from '../../../spacesPlatform/contentDefinitions/getDefaultFilters';


export const DatasourceDefinition: MixedContentItemDefinition & SpaceDefinition<'datasource'> = {
  itemType: 'datasource',
  contentType: 'datasource',
  singularName: Messages.datasource,
  pluralName: Messages.datasources,
  emptyStateMessage: Messages.datasourcesEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Datasources,
  contentFilterKeys: DatasourceContentType.filterKeys,
  defaultFilters: getDataSourceDefaultFilters,
  cardComponent: DatasourceCard,
  listViewIconUrl: imgPath('datasource_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['datasource']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.exploreDatasourceUrl(contentId),
  getBasicQuery: () => {
    return DataSources.all().withExtraParams(DatasourceContentType.extraQueryParams);
  },
  fieldValueResourceType: 'datasource',
  getContentInfo: (contentList: IContentInfo[]) => call(getDatasourceInfos, contentList),
  headerIconPath: (contentInfo: IDataSourceInfo) => DataSources.getIconForDatasourceType(contentInfo, 'masthead'),
  supportedDisplayModes: ['list', 'thumbnail'],
  detailDialogTitle: Messages.datasourceDetailsTitle,
  detailDialogBody: (content: IContentInfo<'datasource'>, availableActions: IDatasourceActions, contentLocation?: string) => {
    return (
      <ConnectedDatasourceDetailsDialogBody
        datasource={content as IDataSourceDetailInfoWithUsage}
        allowedActions={availableActions}
        location={contentLocation}
      />
    );
  },
};
